// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProseMirror ol {
  list-style-type: decimal; /* list-decimal */
}

.ProseMirror ul {
  list-style-type: disc; /* list-disc */
}

.ProseMirror ul,
.ProseMirror ol {
  padding-top: 0; /* py-0 */
  padding-bottom: 0; /* py-0 */
  padding-left: 2rem; /* px-8 */
  padding-right: 2rem; /* px-8 */
  margin-top: 1.5rem; /* my-6 */
  margin-bottom: 1.5rem; /* my-6 */
}

.ProseMirror ul:first-child,
.ProseMirror ol:first-child {
  margin-top: 0; /* first:mt-0 */
}

.ProseMirror ul:last-child,
.ProseMirror ol:last-child {
  margin-bottom: 0; /* last:mb-0 */
}

.ProseMirror ul ul,
.ProseMirror ul ol,
.ProseMirror ul li,
.ProseMirror ol ul,
.ProseMirror ol ol,
.ProseMirror ol li {
  margin-top: 0.25rem; /* my-1 */
  margin-bottom: 0.25rem; /* my-1 */
}

.ProseMirror ul p,
.ProseMirror ol p {
  margin-top: 0; /* mt-0 */
  margin-bottom: 0.25rem; /* mb-1 */
}

.ProseMirror > ul,
.ProseMirror > ol {
  margin-top: 2rem; /* my-8 */
  margin-bottom: 2rem; /* my-8 */
}

.ProseMirror > ul:first-child,
.ProseMirror > ol:first-child {
  margin-top: 0; /* first:mt-0 */
}

.ProseMirror > ul:last-child,
.ProseMirror > ol:last-child {
  margin-bottom: 0; /* last:mb-0 */
}

.ProseMirror ul[data-type="taskList"] {
  list-style-type: none; /* list-none */
  padding: 0; /* p-0 */
}

.ProseMirror ul[data-type="taskList"] p {
  margin: 0; /* m-0 */
}

.ProseMirror ul[data-type="taskList"] li {
  display: flex; /* flex */
}

.ProseMirror ul[data-type="taskList"] li > label {
  flex-grow: 0; /* grow-0 */
  flex-shrink: 0; /* shrink-0 */
  flex-basis: auto; /* flex-auto */
  margin-top: 0.25rem; /* mt-1 */
  margin-right: 0.5rem; /* mr-2 */
  user-select: none; /* select-none */
}

.ProseMirror ul[data-type="taskList"] li > div {
  flex-basis: auto; /* flex-auto */
}

.ProseMirror ul[data-type="taskList"] li[data-checked="true"] {
  text-decoration: line-through; /* line-through */
}
`, "",{"version":3,"sources":["webpack://./src/components/Reusable/RichTextEditor/src/styles/partials/lists.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB,EAAE,iBAAiB;AAC7C;;AAEA;EACE,qBAAqB,EAAE,cAAc;AACvC;;AAEA;;EAEE,cAAc,EAAE,SAAS;EACzB,iBAAiB,EAAE,SAAS;EAC5B,kBAAkB,EAAE,SAAS;EAC7B,mBAAmB,EAAE,SAAS;EAC9B,kBAAkB,EAAE,SAAS;EAC7B,qBAAqB,EAAE,SAAS;AAClC;;AAEA;;EAEE,aAAa,EAAE,eAAe;AAChC;;AAEA;;EAEE,gBAAgB,EAAE,cAAc;AAClC;;AAEA;;;;;;EAME,mBAAmB,EAAE,SAAS;EAC9B,sBAAsB,EAAE,SAAS;AACnC;;AAEA;;EAEE,aAAa,EAAE,SAAS;EACxB,sBAAsB,EAAE,SAAS;AACnC;;AAEA;;EAEE,gBAAgB,EAAE,SAAS;EAC3B,mBAAmB,EAAE,SAAS;AAChC;;AAEA;;EAEE,aAAa,EAAE,eAAe;AAChC;;AAEA;;EAEE,gBAAgB,EAAE,cAAc;AAClC;;AAEA;EACE,qBAAqB,EAAE,cAAc;EACrC,UAAU,EAAE,QAAQ;AACtB;;AAEA;EACE,SAAS,EAAE,QAAQ;AACrB;;AAEA;EACE,aAAa,EAAE,SAAS;AAC1B;;AAEA;EACE,YAAY,EAAE,WAAW;EACzB,cAAc,EAAE,aAAa;EAC7B,gBAAgB,EAAE,cAAc;EAChC,mBAAmB,EAAE,SAAS;EAC9B,oBAAoB,EAAE,SAAS;EAC/B,iBAAiB,EAAE,gBAAgB;AACrC;;AAEA;EACE,gBAAgB,EAAE,cAAc;AAClC;;AAEA;EACE,6BAA6B,EAAE,iBAAiB;AAClD","sourcesContent":[".ProseMirror ol {\n  list-style-type: decimal; /* list-decimal */\n}\n\n.ProseMirror ul {\n  list-style-type: disc; /* list-disc */\n}\n\n.ProseMirror ul,\n.ProseMirror ol {\n  padding-top: 0; /* py-0 */\n  padding-bottom: 0; /* py-0 */\n  padding-left: 2rem; /* px-8 */\n  padding-right: 2rem; /* px-8 */\n  margin-top: 1.5rem; /* my-6 */\n  margin-bottom: 1.5rem; /* my-6 */\n}\n\n.ProseMirror ul:first-child,\n.ProseMirror ol:first-child {\n  margin-top: 0; /* first:mt-0 */\n}\n\n.ProseMirror ul:last-child,\n.ProseMirror ol:last-child {\n  margin-bottom: 0; /* last:mb-0 */\n}\n\n.ProseMirror ul ul,\n.ProseMirror ul ol,\n.ProseMirror ul li,\n.ProseMirror ol ul,\n.ProseMirror ol ol,\n.ProseMirror ol li {\n  margin-top: 0.25rem; /* my-1 */\n  margin-bottom: 0.25rem; /* my-1 */\n}\n\n.ProseMirror ul p,\n.ProseMirror ol p {\n  margin-top: 0; /* mt-0 */\n  margin-bottom: 0.25rem; /* mb-1 */\n}\n\n.ProseMirror > ul,\n.ProseMirror > ol {\n  margin-top: 2rem; /* my-8 */\n  margin-bottom: 2rem; /* my-8 */\n}\n\n.ProseMirror > ul:first-child,\n.ProseMirror > ol:first-child {\n  margin-top: 0; /* first:mt-0 */\n}\n\n.ProseMirror > ul:last-child,\n.ProseMirror > ol:last-child {\n  margin-bottom: 0; /* last:mb-0 */\n}\n\n.ProseMirror ul[data-type=\"taskList\"] {\n  list-style-type: none; /* list-none */\n  padding: 0; /* p-0 */\n}\n\n.ProseMirror ul[data-type=\"taskList\"] p {\n  margin: 0; /* m-0 */\n}\n\n.ProseMirror ul[data-type=\"taskList\"] li {\n  display: flex; /* flex */\n}\n\n.ProseMirror ul[data-type=\"taskList\"] li > label {\n  flex-grow: 0; /* grow-0 */\n  flex-shrink: 0; /* shrink-0 */\n  flex-basis: auto; /* flex-auto */\n  margin-top: 0.25rem; /* mt-1 */\n  margin-right: 0.5rem; /* mr-2 */\n  user-select: none; /* select-none */\n}\n\n.ProseMirror ul[data-type=\"taskList\"] li > div {\n  flex-basis: auto; /* flex-auto */\n}\n\n.ProseMirror ul[data-type=\"taskList\"] li[data-checked=\"true\"] {\n  text-decoration: line-through; /* line-through */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
